export default __webpack_public_path__ + "static/media/back1.d45397fd.svg";